module.exports = __webpack_public_path__ + "img/bg123.e5132c4d.png";